export type StoredCookieConsent = "accepted" | "declined" | null;

/** Reads `cookie_consent` from localStorage (ConsentDock / legacy banner). */
export function getStoredCookieConsent(): StoredCookieConsent {
  if (typeof window === "undefined") return null;
  const value = localStorage.getItem("cookie_consent");
  if (value === "accepted" || value === "declined") return value;
  return null;
}
